import { useLocation, useNavigate } from "react-router";
import * as S from "./MenuItem.styel";
import { ReactComponent as IconArrow } from "../../../styles/assets/svg/icon_sidemenu_arrow.svg";

interface MenuItemProps {
  data: any;
}

export const MenuItem = (props: MenuItemProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <S.MenuItem
      $active={location.pathname.includes(props.data.path) ? true : false}
      onClick={() => navigate(`${props.data.path}`)}
    >
      <S.MenuTit>{props.data.menu_name}</S.MenuTit>
      <IconArrow transform="rotate(180)" width={20} height={20} />
    </S.MenuItem>
  );
};
